<!-- Navigation -->
<div class="header">
  <header class="full-width">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 mainNavCol">
          <!-- logo -->
          <div class="logo mainNavCol">
            <a
              routerLink="/"
              style="
                cursor: pointer;
                touch-action: manipulation;
                display: inline-block;
              "
            >
              <img src="assets/icons/logo.svg" class="img-fluid" alt="Logo" />
            </a>
          </div>
          <!-- logo -->
          <div class="main-search mainNavCol">
            <div class="main-search search-form full-width">
              <div class="row">
                <!-- location picker -->
                <div class="col-lg-6 col-md-5">
                  <a
                    href="javascript:void(0)"
                    class="delivery-add p-relative"
                    (click)="toggleZipCodeInput()"
                    (touchend)="toggleZipCodeInput(); $event.preventDefault()"
                    style="cursor: pointer; touch-action: manipulation"
                  >
                    <span class="icon"
                      ><i class="fas fa-map-marker-alt"></i
                    ></span>
                    <span class="address">
                      <span *ngIf="isLoadingLocation">Loading location...</span>
                      <span *ngIf="!isLoadingLocation">{{
                        currentLocationName$ | async
                      }}</span>
                    </span>
                  </a>
                  <form
                    [formGroup]="zipCodeForm"
                    (ngSubmit)="onZipCodeSubmit()"
                    *ngIf="showZipCodeInput"
                    style="margin-top: 10px"
                  >
                    <div class="location-picker" style="display: flex">
                      <input
                        type="text"
                        name="zipCode"
                        class="form-control"
                        placeholder="Enter a new zip code"
                        formControlName="zipCode"
                        maxlength="5"
                        pattern="[0-9]{5}"
                      />
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="useCurrentLocation()"
                        (touchend)="
                          useCurrentLocation(); $event.preventDefault()
                        "
                        [disabled]="isLoadingLocation"
                        style="
                          white-space: nowrap;
                          padding: 1px 16px;
                          cursor: pointer;
                          touch-action: manipulation;
                          min-height: 44px;
                          min-width: 44px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        title="Use current location"
                      >
                        <i
                          class="fas fa-map-marker-alt"
                          *ngIf="!isLoadingLocation"
                        ></i>
                        <span
                          class="spinner-border spinner-border-sm"
                          *ngIf="isLoadingLocation"
                          role="status"
                        >
                          <span class="sr-only">Loading...</span>
                        </span>
                        <span
                          *ngIf="!isLoadingLocation"
                          style="margin-left: 5px"
                          >Current</span
                        >
                      </button>
                    </div>
                    <small
                      *ngIf="
                        zipCodeForm.get('zipCode')?.invalid &&
                        zipCodeForm.get('zipCode')?.touched
                      "
                      style="
                        color: hsl(0.41deg, 75.51%, 38.43%);
                        display: block;
                        margin-top: 5px;
                      "
                    >
                      Please enter a valid 5-digit ZIP code
                    </small>
                  </form>
                </div>
                <!-- location picker -->
                <!-- search -->
                <div class="col-lg-6 col-md-7">
                  <div class="search-box padding-10" style="position: relative">
                    <form
                      (submit)="onSearchSubmit($event)"
                      style="position: relative"
                    >
                      <input
                        #searchInput
                        type="text"
                        class="form-control"
                        placeholder="Search for a store"
                        [(ngModel)]="searchTerm"
                        (input)="onSearchInput($event)"
                        (focus)="onSearchInputFocus()"
                        name="searchTerm"
                        autocomplete="off"
                        style="padding-right: 40px"
                      />
                      <button
                        type="button"
                        *ngIf="searchTerm"
                        (click)="clearSearch()"
                        (touchend)="clearSearch(); $event.preventDefault()"
                        style="
                          position: absolute;
                          right: 10px;
                          top: 50%;
                          transform: translateY(-50%);
                          background: none;
                          border: none;
                          cursor: pointer;
                          padding: 5px;
                          min-width: 44px;
                          min-height: 44px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          touch-action: manipulation;
                        "
                        title="Clear search"
                      >
                        <i class="fas fa-times text-muted"></i>
                      </button>
                      <button
                        type="submit"
                        (touchend)="
                          onSearchSubmit($event); $event.preventDefault()
                        "
                        style="
                          position: absolute;
                          right: 35px;
                          top: 50%;
                          transform: translateY(-50%);
                          background: none;
                          border: none;
                          cursor: pointer;
                          padding: 5px;
                          min-width: 44px;
                          min-height: 44px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          touch-action: manipulation;
                        "
                        title="Search"
                      >
                        <i class="fas fa-search text-muted"></i>
                      </button>
                    </form>

                    <!-- Autocomplete Dropdown -->
                    <div
                      #autocompleteContainer
                      *ngIf="showSuggestions || showResults"
                      class="autocomplete-dropdown"
                      style="
                        position: absolute;
                        top: 100%;
                        left: 0;
                        right: 0;
                        background: white;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                        z-index: 1000;
                        max-height: 400px;
                        overflow-y: auto;
                        margin-top: 5px;
                      "
                    >
                      <!-- Query Suggestions -->
                      <div
                        *ngIf="showSuggestions && querySuggestions.length > 0"
                        class="suggestions-section"
                      >
                        <div
                          class="section-header"
                          style="
                            padding: 10px 15px;
                            background-color: #f5f5f5;
                            border-bottom: 1px solid #ddd;
                            font-weight: 600;
                            font-size: 12px;
                            color: #666;
                          "
                        >
                          <i
                            class="fas fa-lightbulb"
                            style="margin-right: 5px"
                          ></i>
                          Suggestions
                        </div>
                        <div
                          *ngFor="
                            let suggestion of querySuggestions;
                            let i = index
                          "
                          class="suggestion-item"
                          (click)="onSuggestionClick(suggestion)"
                          (touchend)="
                            onSuggestionClick(suggestion);
                            $event.preventDefault()
                          "
                          style="
                            padding: 10px 15px;
                            cursor: pointer;
                            border-bottom: 1px solid #f0f0f0;
                            transition: background-color 0.2s;
                            touch-action: manipulation;
                            min-height: 44px;
                            display: flex;
                            align-items: center;
                          "
                          [style.background-color]="
                            i === querySuggestions.length - 1
                              ? 'transparent'
                              : ''
                          "
                          onmouseover="this.style.backgroundColor='#f5f5f5'"
                          onmouseout="this.style.backgroundColor='white'"
                        >
                          <i
                            class="fas fa-search text-muted"
                            style="margin-right: 10px; font-size: 12px"
                          ></i>
                          <span [innerHTML]="suggestion.highlighted"></span>
                        </div>
                      </div>

                      <!-- Search Results -->
                      <div *ngIf="showResults" class="results-section">
                        <div
                          class="section-header"
                          style="
                            padding: 10px 15px;
                            background-color: #f5f5f5;
                            border-bottom: 1px solid #ddd;
                            font-weight: 600;
                            font-size: 12px;
                            color: #666;
                          "
                        >
                          <i class="fas fa-store" style="margin-right: 5px"></i>
                          Businesses
                        </div>
                        <div
                          *ngIf="isLoadingSearch"
                          class="text-center"
                          style="padding: 20px"
                        >
                          <div
                            class="spinner-border spinner-border-sm text-primary"
                            role="status"
                          ></div>
                        </div>
                        <div
                          *ngIf="!isLoadingSearch && searchResults.length === 0"
                          class="text-center"
                          style="padding: 20px; color: #666"
                        >
                          <p style="margin: 0; font-size: 14px">
                            No businesses found
                          </p>
                        </div>
                        <div
                          *ngFor="let business of searchResults; let i = index"
                          class="result-item"
                          (click)="onSearchResultClick(business, i)"
                          (touchend)="
                            onSearchResultClick(business, i);
                            $event.preventDefault()
                          "
                          style="
                            padding: 12px 15px;
                            cursor: pointer;
                            border-bottom: 1px solid #f0f0f0;
                            transition: background-color 0.2s;
                            touch-action: manipulation;
                            min-height: 44px;
                          "
                          [style.background-color]="
                            i === searchResults.length - 1 ? 'transparent' : ''
                          "
                          onmouseover="this.style.backgroundColor='#f5f5f5'"
                          onmouseout="this.style.backgroundColor='white'"
                        >
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              position: relative;
                            "
                          >
                            <!-- Store Logo Skeleton -->
                            <div
                              *ngIf="isStoreLogoLoading(business.id)"
                              class="store-logo-skeleton"
                              style="margin-right: 12px"
                            ></div>
                            <!-- Store Logo -->
                            <img
                              *ngIf="
                                business.storeLogo ||
                                !isStoreLogoLoading(business.id)
                              "
                              [src]="
                                business.storeLogo || 'assets/img/logo-3.jpg'
                              "
                              style="
                                width: 40px;
                                height: 40px;
                                border-radius: 4px;
                                object-fit: cover;
                                margin-right: 12px;
                                position: relative;
                                z-index: 1;
                              "
                              [alt]="business.storeName"
                              [attr.data-loading]="
                                isStoreLogoLoading(business.id)
                              "
                              (load)="onStoreLogoLoad(business.id)"
                              (error)="onStoreLogoError(business.id)"
                              [style.opacity]="
                                isStoreLogoLoading(business.id) ? '0' : '1'
                              "
                              [style.transition]="'opacity 0.3s ease-in-out'"
                              onerror="this.src='assets/img/logo-3.jpg'"
                            />
                            <div style="flex: 1">
                              <p
                                class="text-light-black fw-600 mb-0"
                                style="font-size: 14px; margin: 0"
                              >
                                {{ business.storeName }}
                              </p>
                              <p
                                class="text-light-white mb-0"
                                style="font-size: 12px; margin: 2px 0 0 0"
                              >
                                <i
                                  class="fas fa-map-marker-alt"
                                  style="margin-right: 4px; font-size: 10px"
                                ></i>
                                {{ business.address
                                }}{{ business.city ? ", " + business.city : ""
                                }}{{
                                  business.state ? ", " + business.state : ""
                                }}
                              </p>
                              <div
                                *ngIf="
                                  business.type && business.type.length > 0
                                "
                                style="margin-top: 4px"
                              >
                                <span
                                  *ngFor="
                                    let type of business.type.slice(0, 2);
                                    let last = last
                                  "
                                  class="badge badge-sm"
                                  style="
                                    background-color: #e3f2fd;
                                    color: #1976d2;
                                    font-size: 10px;
                                    padding: 2px 6px;
                                    margin-right: 4px;
                                  "
                                >
                                  {{ type }}
                                </span>
                              </div>
                            </div>
                            <i
                              class="fas fa-chevron-right text-muted"
                              style="margin-left: 10px; font-size: 12px"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- search -->
              </div>
            </div>
          </div>
          <div class="right-side fw-700 mainNavCol">
            <!-- mobile search -->
            <div class="mobile-search">
              <a
                href="javascript:void(0)"
                (click)="openMobileSearchModal(); $event.preventDefault()"
                (touchend)="openMobileSearchModal(); $event.preventDefault()"
              >
                <i class="fas fa-search"></i>
              </a>
            </div>
            <!-- mobile search -->
            <!-- user account -->
            <ng-container *ngIf="vm$ | async as vm">
              <div
                class="user-details p-relative"
                *ngIf="vm.isAuthenticated"
                #userDropdownContainer
              >
                <a
                  href="javascript:void(0)"
                  class="text-light-white fw-500"
                  #userDetailsLink
                  (click)="toggleUserDropdown($event)"
                  (touchend)="
                    toggleUserDropdown($event); $event.preventDefault()
                  "
                  style="cursor: pointer; touch-action: manipulation"
                >
                  <!-- Avatar Skeleton -->
                  <div
                    *ngIf="isUserAvatarLoading"
                    class="avatar-skeleton"
                    style="margin-right: 8px"
                  ></div>
                  <img
                    [src]="
                      getUserPhotoUrl(vm.userProfile) ||
                      'assets/img/user/user-icon.svg'
                    "
                    class="rounded-circle user-image"
                    alt="userimg"
                    [attr.data-loading]="isUserAvatarLoading"
                    (load)="onUserAvatarLoad()"
                    (error)="onUserAvatarError()"
                    [style.display]="isUserAvatarLoading ? 'none' : 'block'"
                    [hidden]="isUserAvatarLoading"
                  />
                  <span>Hi, {{ getUserDisplayName(vm.userProfile) }}</span>
                </a>
                <div
                  class="user-dropdown"
                  [class.show]="showUserDropdown"
                  (click)="$event.stopPropagation()"
                >
                  <ul style="display: flex; gap: 5px; flex-wrap: wrap">
                    <li>
                      <a
                        routerLink="/appointments"
                        (click)="closeUserDropdown()"
                        style="
                          cursor: pointer;
                          touch-action: manipulation;
                          display: flex;
                          align-items: center;
                          min-height: 44px;
                        "
                      >
                        <div class="icon">
                          <i class="flaticon-takeaway"></i>
                        </div>
                        <span class="details">Appointments</span>
                      </a>
                    </li>
                    <li>
                      <a
                        routerLink="/account"
                        (click)="closeUserDropdown()"
                        style="
                          cursor: pointer;
                          touch-action: manipulation;
                          display: flex;
                          align-items: center;
                          min-height: 44px;
                        "
                      >
                        <div class="icon"><i class="flaticon-user"></i></div>
                        <span class="details">Account</span>
                      </a>
                    </li>
                  </ul>
                  <div class="user-footer">
                    <span class="text-light-black"
                      >Not {{ getUserDisplayName(vm.userProfile) }}?</span
                    >
                    <a
                      href="javascript:void(0)"
                      (click)="signOut()"
                      (touchend)="signOut(); $event.preventDefault()"
                      style="
                        cursor: pointer;
                        touch-action: manipulation;
                        min-height: 44px;
                        display: inline-flex;
                        align-items: center;
                      "
                    >
                      Sign Out
                    </a>
                  </div>
                </div>
              </div>
              <div class="user-details p-relative" *ngIf="!vm.isAuthenticated">
                <a
                  routerLink="/auth/sign-in"
                  class="text-light-white fw-500"
                  style="
                    cursor: pointer;
                    touch-action: manipulation;
                    display: inline-flex;
                    align-items: center;
                    min-height: 44px;
                  "
                >
                  <i class="fas fa-user"></i>
                  <span>Sign In</span>
                </a>
              </div>
            </ng-container>
            <!-- mobile search -->
            <!-- user notification -->
            <app-notification-dropdown></app-notification-dropdown>
            <!-- user notification -->
            <!-- user cart -->
            <div
              class="cart-btn cart-dropdown p-relative"
              #cartDropdownContainer
            >
              <a
                href="javascript:void(0)"
                class="text-light-green fw-700 cart-link"
                #cartLink
                (click)="toggleCartDropdown($event)"
                (touchend)="toggleCartDropdown($event); $event.preventDefault()"
                style="
                  cursor: pointer;
                  touch-action: manipulation;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  min-height: 44px;
                  min-width: 44px;
                  position: relative;
                "
                title="Cart"
              >
                <i class="fas fa-shopping-bag"></i>
                <span
                  class="user-alert-cart"
                  *ngIf="
                    (cartItemCount$ | async) && (cartItemCount$ | async)! > 0
                  "
                >
                  {{
                    (cartItemCount$ | async)! > 9
                      ? "9+"
                      : (cartItemCount$ | async)
                  }}
                </span>
              </a>
              <div
                class="cart-detail-box"
                [class.show]="showCartDropdown"
                (click)="$event.stopPropagation()"
              >
                <div class="card">
                  <div class="card-header padding-15">Your Order</div>
                  <div class="card-body no-padding" id="scrollstyle-4">
                    <!-- Empty Cart -->
                    <div
                      *ngIf="isCartEmpty$ | async"
                      class="text-center"
                      style="padding: 40px"
                    >
                      <p class="text-light-black">Your cart is empty</p>
                    </div>

                    <!-- Cart Items by Store -->
                    <ng-container *ngFor="let storeCart of storeCarts$ | async">
                      <div
                        *ngIf="storeCart.storeName"
                        class="store-cart-header padding-15"
                        style="
                          background-color: #f5f5f5;
                          border-bottom: 1px solid #ddd;
                        "
                      >
                        <h6 class="text-light-black fw-700 mb-0">
                          {{ storeCart.storeName }}
                        </h6>
                      </div>
                      <div
                        *ngFor="let item of storeCart.items"
                        class="cat-product-box"
                      >
                        <div class="cat-product">
                          <div class="cat-name">
                            <a href="javascript:void(0)">
                              <p class="text-light-green fw-700">
                                <span class="text-dark-white">1</span>
                                {{ getItemDescription(item) }}
                              </p>
                              <span
                                class="text-light-white fw-700"
                                *ngIf="item.date"
                              >
                                {{ formatDate(item.date) }} at
                                {{ formatTime(item.startTime) }}
                              </span>
                              <span
                                class="text-light-white fw-700"
                                *ngIf="item.staffName"
                              >
                                Staff: {{ item.staffName }}
                              </span>
                              <span
                                class="text-light-white fw-700"
                                *ngIf="item.duration"
                              >
                                Duration: {{ item.duration }} min
                              </span>
                            </a>
                          </div>
                          <div class="delete-btn">
                            <a
                              href="javascript:void(0)"
                              class="text-dark-white"
                              (click)="
                                removeCartItem(storeCart.storeId, item.id)
                              "
                              (touchend)="
                                removeCartItem(storeCart.storeId, item.id);
                                $event.preventDefault()
                              "
                              style="
                                cursor: pointer;
                                touch-action: manipulation;
                                min-height: 44px;
                                min-width: 44px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding: 10px;
                              "
                              title="Remove item"
                            >
                              <i class="far fa-trash-alt"></i>
                            </a>
                          </div>
                          <div class="price">
                            <a
                              href="javascript:void(0)"
                              class="text-dark-white fw-500"
                            >
                              {{ formatPrice(item.totalPrice) }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <div class="item-total" *ngIf="!(isCartEmpty$ | async)">
                      <div class="total-price border-0">
                        <span class="text-dark-white fw-700"
                          >Items subtotal:</span
                        >
                        <span class="text-dark-white fw-700">{{
                          cartTotalPrice$
                            | async
                            | currency : "USD" : "symbol" : "1.2-2"
                        }}</span>
                      </div>
                      <div class="empty-bag padding-15 fw-700">
                        <a
                          href="javascript:void(0)"
                          (click)="clearCart()"
                          (touchend)="clearCart(); $event.preventDefault()"
                          style="
                            cursor: pointer;
                            touch-action: manipulation;
                            min-height: 44px;
                            display: inline-flex;
                            align-items: center;
                          "
                        >
                          Empty bag
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer padding-15"
                    *ngIf="!(isCartEmpty$ | async)"
                  >
                    <a
                      routerLink="/checkout"
                      class="btn-first green-btn text-custom-white full-width fw-500"
                      (click)="closeCartDropdown()"
                      (touchend)="closeCartDropdown(); $event.preventDefault()"
                      style="
                        cursor: pointer;
                        touch-action: manipulation;
                        min-height: 44px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                      >Book now</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- user cart -->
          </div>
        </div>
        <div class="col-sm-12 mobile-search">
          <div class="mobile-address">
            <a
              href="javascript:void(0)"
              class="delivery-add"
              (click)="toggleMobileZipCodeInput()"
              (touchend)="toggleMobileZipCodeInput(); $event.preventDefault()"
              style="
                cursor: pointer;
                touch-action: manipulation;
                display: flex;
                align-items: center;
                gap: 10px;
                min-height: 44px;
              "
            >
              <span class="icon">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              <span class="address">
                <span *ngIf="isLoadingLocation">Loading location...</span>
                <span *ngIf="!isLoadingLocation">{{
                  currentLocationName$ | async
                }}</span>
              </span>
            </a>
            <form
              [formGroup]="zipCodeForm"
              (ngSubmit)="onZipCodeSubmit()"
              *ngIf="showMobileZipCodeInput"
              style="margin-top: 10px"
            >
              <div class="location-picker" style="display: flex">
                <input
                  type="text"
                  name="zipCode"
                  class="form-control form-control-submit"
                  placeholder="Enter ZIP code"
                  formControlName="zipCode"
                  maxlength="5"
                  pattern="[0-9]{5}"
                />
                <button
                  type="button"
                  class="btn-primary"
                  (click)="useCurrentLocation()"
                  (touchend)="useCurrentLocation(); $event.preventDefault()"
                  [disabled]="isLoadingLocation"
                  style="
                    white-space: nowrap;
                    padding: 21px 12px;
                    cursor: pointer;
                    touch-action: manipulation;
                    min-height: 44px;
                    min-width: 44px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  title="Use current location"
                >
                  <i
                    class="fas fa-map-marker-alt"
                    *ngIf="!isLoadingLocation"
                  ></i>
                  <span
                    class="spinner-border spinner-border-sm"
                    *ngIf="isLoadingLocation"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </span>
                  <span *ngIf="!isLoadingLocation" style="margin-left: 5px"
                    >Current</span
                  >
                </button>
              </div>
              <small
                *ngIf="
                  zipCodeForm.get('zipCode')?.invalid &&
                  zipCodeForm.get('zipCode')?.touched
                "
                style="
                  color: hsl(0.41deg, 75.51%, 38.43%);
                  display: block;
                  margin-top: 5px;
                  font-size: 12px;
                "
              >
                Please enter a valid 5-digit ZIP code
              </small>
            </form>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

<!-- Mobile Search Modal -->
<div
  *ngIf="showMobileSearchModal"
  class="mobile-search-modal-overlay"
  (click)="closeMobileSearchModal()"
  (touchend)="closeMobileSearchModal(); $event.preventDefault()"
  style="
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 60px;
  "
>
  <div
    class="mobile-search-modal"
    (click)="$event.stopPropagation()"
    (touchend)="$event.stopPropagation()"
    style="
      background: white;
      width: 100%;
      max-width: 100%;
      max-height: calc(100vh - 60px);
      border-radius: 8px 8px 0 0;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      overflow: hidden;
    "
  >
    <!-- Modal Header -->
    <div
      class="modal-header"
      style="
        padding: 15px;
        border-bottom: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <h5 style="margin: 0; font-weight: 600; color: #333">
        Search for a store
      </h5>
      <button
        type="button"
        class="btn btn-link"
        (click)="closeMobileSearchModal()"
        (touchend)="closeMobileSearchModal(); $event.preventDefault()"
        style="
          background: none;
          border: none;
          padding: 5px;
          cursor: pointer;
          min-width: 44px;
          min-height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          touch-action: manipulation;
        "
        title="Close"
      >
        <i class="fas fa-times" style="font-size: 20px; color: #666"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div
      class="modal-body"
      style="
        padding: 15px;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
      "
    >
      <!-- Search Input -->
      <div
        class="search-box"
        style="position: relative; margin-bottom: 10px; flex-shrink: 0"
      >
        <form
          (submit)="onMobileSearchSubmit($event)"
          style="position: relative"
        >
          <input
            #mobileSearchInput
            type="text"
            class="form-control"
            placeholder="Search for a store"
            [(ngModel)]="mobileSearchTerm"
            (input)="onMobileSearchInput($event)"
            (focus)="onMobileSearchInputFocus()"
            name="mobileSearchTerm"
            autocomplete="off"
            style="
              padding-right: 80px;
              width: 100%;
              box-sizing: border-box;
              font-size: 16px;
              min-height: 44px;
            "
          />
          <button
            type="button"
            *ngIf="mobileSearchTerm"
            (click)="clearMobileSearch()"
            (touchend)="clearMobileSearch(); $event.preventDefault()"
            style="
              position: absolute;
              right: 45px;
              top: 50%;
              transform: translateY(-50%);
              background: none;
              border: none;
              cursor: pointer;
              padding: 5px;
              min-width: 44px;
              min-height: 44px;
              display: flex;
              align-items: center;
              justify-content: center;
              touch-action: manipulation;
            "
            title="Clear search"
          >
            <i class="fas fa-times text-muted"></i>
          </button>
          <button
            type="submit"
            (touchend)="onMobileSearchSubmit($event); $event.preventDefault()"
            style="
              position: absolute;
              right: 5px;
              top: 50%;
              transform: translateY(-50%);
              background: none;
              border: none;
              cursor: pointer;
              padding: 5px;
              min-width: 44px;
              min-height: 44px;
              display: flex;
              align-items: center;
              justify-content: center;
              touch-action: manipulation;
            "
            title="Search"
          >
            <i class="fas fa-search text-muted"></i>
          </button>
        </form>
      </div>

      <!-- Autocomplete Dropdown -->
      <div
        #mobileAutocompleteContainer
        *ngIf="showMobileSuggestions || showMobileResults"
        class="autocomplete-dropdown mobile-search-dropdown"
        style="
          background: white;
          border: 1px solid #ddd;
          border-radius: 4px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          flex: 1 1 auto;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          min-height: 100px;
          max-height: calc(100vh - 220px);
          margin-top: 0;
        "
      >
        <!-- Query Suggestions -->
        <div
          *ngIf="showMobileSuggestions && mobileQuerySuggestions.length > 0"
          class="suggestions-section"
        >
          <div
            class="section-header"
            style="
              padding: 10px 15px;
              background-color: #f5f5f5;
              border-bottom: 1px solid #ddd;
              font-weight: 600;
              font-size: 12px;
              color: #666;
              position: sticky;
              top: 0;
              z-index: 10;
            "
          >
            <i class="fas fa-lightbulb" style="margin-right: 5px"></i>
            Suggestions
          </div>
          <div
            *ngFor="let suggestion of mobileQuerySuggestions; let i = index"
            class="suggestion-item"
            (click)="onMobileSuggestionClick(suggestion)"
            (touchend)="
              onMobileSuggestionClick(suggestion); $event.preventDefault()
            "
            style="
              padding: 12px 15px;
              cursor: pointer;
              border-bottom: 1px solid #f0f0f0;
              transition: background-color 0.2s;
              touch-action: manipulation;
              min-height: 44px;
              display: flex;
              align-items: center;
            "
          >
            <i
              class="fas fa-search text-muted"
              style="margin-right: 10px; font-size: 12px"
            ></i>
            <span [innerHTML]="suggestion.highlighted"></span>
          </div>
        </div>

        <!-- Search Results -->
        <div *ngIf="showMobileResults" class="results-section">
          <div
            class="section-header"
            style="
              padding: 10px 15px;
              background-color: #f5f5f5;
              border-bottom: 1px solid #ddd;
              font-weight: 600;
              font-size: 12px;
              color: #666;
              position: sticky;
              top: 0;
              z-index: 10;
            "
          >
            <i class="fas fa-store" style="margin-right: 5px"></i>
            Businesses
          </div>
          <div
            *ngIf="isLoadingMobileSearch"
            class="text-center"
            style="padding: 20px"
          >
            <div
              class="spinner-border spinner-border-sm text-primary"
              role="status"
            ></div>
          </div>
          <div
            *ngIf="!isLoadingMobileSearch && mobileSearchResults.length === 0"
            class="text-center"
            style="padding: 20px; color: #666"
          >
            <p style="margin: 0; font-size: 14px">No businesses found</p>
          </div>
          <div
            *ngFor="let business of mobileSearchResults; let i = index"
            class="result-item"
            (click)="onMobileSearchResultClick(business, i)"
            (touchend)="
              onMobileSearchResultClick(business, i); $event.preventDefault()
            "
            style="
              padding: 12px 15px;
              cursor: pointer;
              border-bottom: 1px solid #f0f0f0;
              transition: background-color 0.2s;
              touch-action: manipulation;
              min-height: 44px;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                position: relative;
              "
            >
              <!-- Mobile Store Logo Skeleton -->
              <div
                *ngIf="isMobileStoreLogoLoading(business.id)"
                class="store-logo-skeleton"
              ></div>
              <!-- Mobile Store Logo -->
              <img
                [src]="
                  business.storeLogo ||
                  'assets/img/restaurants/90x90/shop-3.jpg'
                "
                [alt]="business.storeName"
                style="
                  width: 40px;
                  height: 40px;
                  object-fit: cover;
                  border-radius: 4px;
                  flex-shrink: 0;
                  position: relative;
                  z-index: 1;
                "
                [attr.data-loading]="isMobileStoreLogoLoading(business.id)"
                (load)="onMobileStoreLogoLoad(business.id)"
                (error)="onMobileStoreLogoError(business.id)"
                [style.opacity]="
                  isMobileStoreLogoLoading(business.id) ? '0' : '1'
                "
                [style.transition]="'opacity 0.3s ease-in-out'"
                onerror="this.src='assets/img/restaurants/90x90/shop-3.jpg'"
              />
              <div style="flex: 1; min-width: 0">
                <p
                  style="
                    margin: 0;
                    font-weight: 600;
                    font-size: 14px;
                    color: #333;
                  "
                >
                  {{ business.storeName }}
                </p>
                <p
                  style="margin: 0; font-size: 12px; color: #666"
                  *ngIf="business.address"
                >
                  {{ business.address }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="main-sec"></div>
<!-- Navigation -->
<!-- Navigation -->
